// re.rejouis.fr — CONFIRMATION : nº de demande, bordereau Mondial Relay, suivi
// en 3 étapes. `demande` = { ref, total, nbJouets, lot?, statut? } renvoyé par la soumission.
// Avec un lot : pas encore d'étiquette (« En attente d'offre ») → étapes de l'offre.
import { Icons, CocheAnimee, Illus } from '../components/ui.jsx';
import EtiquetteQr from '../components/EtiquetteQr.jsx';
import { fmtEuro } from '../lib/format.js';

const ETAPES_LOT = [
  { t: 'On évalue ton lot', s: 'Offre sous 14 jours maximum, par e-mail et dans ton espace.', etat: 'encours' },
  { t: 'Tu acceptes ou tu retires le lot', s: 'Depuis « Mes demandes de reprise ». Tes jouets reconnus restent au prix affiché.', etat: 'afaire' },
  { t: 'Tu reçois ton étiquette', s: 'Mondial Relay, offerte : un seul colis pour tout.', etat: 'afaire' },
  { t: 'Crédit sur ton compte', s: 'Versé 2 jours après réception, sans date limite.', etat: 'afaire' },
];

const ETAPES = [
  { t: 'Tu envoies ton colis', s: 'Point relais le plus proche, c’est offert.', etat: 'encours' },
  { t: 'On vérifie au labo', s: 'Ton crédit est confirmé 2 jours après réception.', etat: 'afaire' },
  { t: 'Crédit sur ton compte', s: 'Versé en crédit boutique, sans date limite.', etat: 'afaire' },
];

export default function Confirmation({ go, demande }) {
  const ref = demande?.ref || '—';
  const total = demande?.total || 0;
  const virement = demande?.montantVirement || 0;
  const nb = demande?.nbJouets || 0;
  const bordereau = demande?.labelUrl || null;
  const lot = demande?.lot || null;
  const etapes = lot ? ETAPES_LOT : ETAPES;

  return (
    <div className="no-scrollbar anim-fade" style={{ height: '100%', overflow: 'auto', padding: '12px 0 40px' }}>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '16px 22px 0', textAlign: 'center' }}>
        <div style={{ position: 'relative' }}>
          <div style={{ padding: '16px 0 8px' }}><CocheAnimee size={96} /></div>
        </div>
        <h1 className="t-display" style={{ fontSize: 32, margin: '4px 0 0' }}>C’est noté !</h1>
        <div style={{ fontSize: 13.5, color: 'var(--stone)', marginTop: 8, lineHeight: 1.6 }}>
          Demande <span className="mono" style={{ fontWeight: 600, color: 'var(--noir)' }}>{ref}</span>
          {nb ? <> · {nb} jouet{nb > 1 ? 's' : ''}</> : null}
          {lot ? <>{nb ? ' + ' : ' · '}un lot de {lot.quantite} jouet{lot.quantite > 1 ? 's' : ''}</> : null}
          {nb ? <> · {virement > 0 ? <>{fmtEuro(virement)} par virement{total > 0 ? <> + {fmtEuro(total)} de crédit</> : null}</> : <>{fmtEuro(total)} de crédit</>}{lot ? ' + l’offre du lot' : ''}</> : null}
        </div>
      </div>

      <div style={{ padding: '20px 18px 0', display: 'flex', flexDirection: 'column', gap: 10 }}>
        {/* Bordereau Mondial Relay — lien réel si généré, sinon repli e-mail.
            Avec un lot : l'étiquette attend la réponse du client à l'offre. */}
        {lot ? (
        <div className="card" style={{ padding: 16 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <Illus nom="verifie" size={46} />
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 700, fontSize: 14 }}>N’envoie rien pour l’instant</div>
              <div style={{ fontSize: 12, color: 'var(--stone)', lineHeight: 1.5 }}>
                On t’envoie l’offre de ton lot sous 14 jours. Ton étiquette arrive dès ta réponse : tu pourras tout envoyer dans un seul colis.
              </div>
            </div>
          </div>
        </div>
        ) : demande?.qrCode ? (
        <div className="card" style={{ padding: 16 }}>
          <EtiquetteQr qrCode={demande.qrCode} refDemande={demande.ref} />
          <div style={{ fontSize: 11.5, color: 'var(--stone)', marginTop: 12, lineHeight: 1.55 }}>
            Un carton solide, les jouets dedans (nettoyés, sans piles si possible), puis dépose le tout en point relais. Ton QR code reste disponible dans « Mes demandes de reprise ».
          </div>
        </div>
        ) : (
        <div className="card" style={{ padding: 16 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <Illus nom="camion" size={46} />
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 700, fontSize: 14 }}>Ton bordereau Mondial Relay</div>
              <div style={{ fontSize: 12, color: 'var(--stone)' }}>
                {bordereau ? 'Prépayé, prêt à imprimer.' : 'On te l’envoie par e-mail, prépayé, sous peu.'}
              </div>
            </div>
          </div>
          {bordereau ? (
            <a className="btn btn-primary btn-block" href={bordereau} target="_blank" rel="noopener noreferrer" style={{ marginTop: 14, textDecoration: 'none' }}>
              <Icons.truck size={16} /> Voir mon bordereau
            </a>
          ) : null}
          <div style={{ fontSize: 11.5, color: 'var(--stone)', marginTop: 12, lineHeight: 1.55 }}>
            Un carton solide, les jouets dedans (nettoyés, sans piles si possible), le bordereau collé dessus, puis dépose le tout en point relais.
          </div>
        </div>
        )}

        <div className="card" style={{ padding: 16 }}>
          <div className="t-overline" style={{ marginBottom: 12 }}>La suite</div>
          {etapes.map((e, i, arr) => (
            <div key={i} style={{ display: 'flex', gap: 12 }}>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <div className={'step-dot ' + e.etat}>{i + 1}</div>
                {i < arr.length - 1 ? <div style={{ width: 2, flex: 1, minHeight: 18, background: 'var(--bord)', margin: '4px 0' }} /> : null}
              </div>
              <div style={{ paddingBottom: i < arr.length - 1 ? 14 : 0 }}>
                <div style={{ fontWeight: 600, fontSize: 13.5 }}>{e.t}</div>
                <div style={{ fontSize: 12, color: 'var(--stone)', lineHeight: 1.5 }}>{e.s}</div>
              </div>
            </div>
          ))}
        </div>

        {/* Petit mot dans le colis : c'est Corentin et Justine qui ouvrent les colis à l'atelier. */}
        <div className="soft-card" style={{ padding: '14px 16px', display: 'flex', gap: 12, alignItems: 'flex-start' }}>
          <span aria-hidden="true" style={{ fontSize: 28, lineHeight: 1, flexShrink: 0, width: 40, textAlign: 'center' }}>💌</span>
          <div style={{ flex: 1 }}>
            <div style={{ fontWeight: 700, fontSize: 13.5, marginBottom: 4 }}>Un petit mot dans le colis&nbsp;?</div>
            <div style={{ fontSize: 12.5, color: 'var(--stone)', lineHeight: 1.55 }}>
              {lot ? 'Quand tu prépareras ton colis, glisse' : 'Glisse'} quelques mots pour <strong>Corentin et Justine</strong>, qui l’ouvriront à l’atelier.
              Rien d’obligatoire&nbsp;: ça leur fait toujours plaisir&nbsp;!
            </div>
          </div>
        </div>

        {/* Petits jouets en plus : le don dans CE colis, sans attendre une offre de lot.
            Une étiquette = une demande = un colis (sinon étiquettes non utilisées, non suivies). */}
        <div className="soft-card" style={{ padding: '14px 16px', display: 'flex', gap: 12, alignItems: 'flex-start' }}>
          <Illus nom="don" size={40} />
          <div style={{ flex: 1 }}>
            <div style={{ fontWeight: 700, fontSize: 13.5, marginBottom: 4 }}>D’autres petits jouets à liquider&nbsp;?</div>
            <div style={{ fontSize: 12.5, color: 'var(--stone)', lineHeight: 1.55 }}>
              Glisse-les <strong>en don</strong> dans ce colis, avec un petit mot «&nbsp;DON&nbsp;»&nbsp;: rien à attendre, on s’occupe de leur seconde vie.
              Pour tes autres demandes de reprise, utilise à chaque fois leur propre étiquette.
            </div>
          </div>
        </div>

        <button className="btn btn-secondary btn-block" onClick={() => go('mes-demandes', demande?.ref ? { ref: demande.ref } : null)}>Suivre ma demande</button>
        <div style={{ fontSize: 11.5, color: 'var(--stone)', textAlign: 'center', lineHeight: 1.5 }}>
          Retrouve ton bordereau et le suivi à tout moment dans « Mes demandes de reprise » de ton compte rejouis.fr.
        </div>
        <button className="btn btn-tertiary btn-block" onClick={() => go('accueil')}>Retour à l’accueil</button>
      </div>
    </div>
  );
}
